<template>
  <div class="voting-key-date-section__wrapper full-width-section">
    <div class="voting-key-date-section__container">
      <h2 class="title-new title-border-new uppercase">
        Key Dates
      </h2>
      <div class="voting-key-date-section__blocks">
        <div
          v-for="block in $options.consts.BLOCKS"
          :key="block.title"
          class="voting-key-date-section__block"
        >
          <p class="voting-key-date-section__block-title">{{ block.title }}</p>
          <p class="voting-key-date-section__block-date">{{ block.date }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VotingKeyDatesSection',
  consts: {
    BLOCKS: [
      {
        title: 'GALA DINNER WINNERS ANNOUNCEMENT',
        date: '6TH NOVEMBER'
      }
    ]
  }
}
</script>

<style lang="scss" scoped>
.voting-key-date-section__wrapper {
  background: $c--black;

  .voting-key-date-section__container {
    max-width: $desktop-container;

    $padding: (
      $above-desktop-xl: 50px $padding-x-desktop-full-hd 64px,
      $desktop-sm: 59px $padding-x-desktop-sm 64px,
      $mobile: 32px $padding-x-mobile
    );

    @include setStyleByBreakpoint('padding', $padding);
  }

  .voting-key-date-section__blocks {
    margin-top: 32px;

    .voting-key-date-section__block {
      background: $c--background-dark-3;
      border-radius: 12px;
      padding: 32px 40px;
    }

    .voting-key-date-section__block-title {
      font-size: 18px;
      line-height: 28px;
      margin-bottom: 8px;
    }

    .voting-key-date-section__block-date {
      font-size: 18px;
      font-weight: 500;
      line-height: 28px;
    }
  }
}
</style>
